import { createStore } from 'zustand/vanilla';

export type HeaderVisibilityState = {
  showBackButton: boolean;
  onBack: (() => void) | undefined;
};

export type HeaderVisibilityActions = {
  setShowBackButton: (visible: boolean) => void;
  setOnBack: (fn: (() => void) | undefined) => void;
};

export type HeaderVisibilityStore = HeaderVisibilityState & HeaderVisibilityActions;

export const defaultInitState: HeaderVisibilityState = {
  showBackButton: false,
  onBack: undefined,
};

export const initHeaderVisibilityStore = (): HeaderVisibilityState => {
  return defaultInitState;
};

export const createHeaderVisibilityStore = (
  initState: HeaderVisibilityState = defaultInitState,
) => {
  return createStore<HeaderVisibilityStore>()((set) => ({
    ...initState,
    setShowBackButton: (visible: boolean) => set({ showBackButton: visible }),
    setOnBack: (fn: (() => void) | undefined) => set({ onBack: fn }),
  }));
};
